import {
    getCrossPromotionAPI,
    postCrossPromotionAPI,
    putCrossPromotionAPI,
    deleteCrossPromotionAPI,
  } from "../api";
  
  export default {
    namespaced: true,
  
    state: {
      data: {
        crossPromotions: [],
        isLoading: false,
      },
    },
  
    getters: {
      getCrossPromotions: (state) => state.data.crossPromotions,
      getCrossPromotionsLoading: (state) => state.data.isLoading,
    },
  
    actions: {
      actionGetCrossPromotions({ commit, rootState }) {
        const { env } = rootState.selectEnv.data;
        commit("SET_IS_LOADING", true);
        return new Promise((resolve, reject) => {
          getCrossPromotionAPI(env).then(
            (response) => {
              commit("SET_CROSS_PROMOTION", response);
              setTimeout(() => {
                commit("SET_IS_LOADING", false);
              }, 1000);
              resolve(response);
            },
            (error) => {
              setTimeout(() => {
                commit("SET_IS_LOADING", false);
              }, 1000);
              reject(error);
            }
          );
        });
      },
  
      actionSetCrossPromotion({ commit }, payload) {
        commit("SET_IS_LOADING", true);
        if (payload && !payload.eventKey) {
          return new Promise((resolve, reject) => {
            postCrossPromotionAPI(payload)
              .then((res) => {
                resolve(res);
              })
              .catch((err) => {
                setTimeout(() => {
                  commit("SET_IS_LOADING", false);
                }, 1000);
                console.log("err: ", err);
                reject(err);
              });
          });
        } else {
          return new Promise((resolve, reject) => {
            putCrossPromotionAPI(payload)
              .then((res) => {
                resolve(res);
              })
              .catch((err) => {
                setTimeout(() => {
                  commit("SET_IS_LOADING", false);
                }, 1000);
                console.log("err: ", err);
                reject(err);
              });
          });
        }
      },
  
      actionDeleteCrossPromotion({ commit }, payload) {
        commit("SET_IS_LOADING", true);
        return new Promise((resolve, reject) => {
          deleteCrossPromotionAPI(payload)
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              setTimeout(() => {
                commit("SET_IS_LOADING", false);
              }, 1000);
              console.log("err: ", err);
              reject(err);
            });
        });
      },
    },
  
    mutations: {
      SET_CROSS_PROMOTION(state, payload) {
        state.data.crossPromotions = payload;
      },
      SET_IS_LOADING(state, payload) {
        state.data.isLoading = payload;
      },
    },
  };
  